var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col-12 mt-2" }, [
      _vm._v(
        "\n        " +
          _vm._s(_vm.resource("JourneyBuilder_FilterSettings_SelectOperator")) +
          "\n    "
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "col-8 mb-2" },
      [
        _c(
          "input-group",
          { attrs: { icon: "fas fa-cog" } },
          [
            _c(
              "v-select",
              {
                staticClass: "form-control",
                attrs: {
                  label: "text",
                  options: _vm.availableOperators,
                  getOptionKey: function(opt) {
                    return opt.value
                  },
                  disabled: !_vm.canWrite,
                  clearable: false
                },
                model: {
                  value: _vm.selectedOperator,
                  callback: function($$v) {
                    _vm.selectedOperator = $$v
                  },
                  expression: "selectedOperator"
                }
              },
              [_c("div", { attrs: { slot: "no-options" }, slot: "no-options" })]
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "col-4 mb-2 d-flex align-items-center" }, [
      _c("b", [
        _vm._v(_vm._s(_vm.resource("JourneyBuilder_FilterSettings_Audience")))
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "col-12" }, [
      _vm._v(
        "\n        " +
          _vm._s(
            _vm.resource("JourneyBuilder_FilterSettings_SelectCondition")
          ) +
          "\n    "
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "col-12" },
      [
        _c(
          "input-group",
          { attrs: { icon: "fas fa-filter" } },
          [
            _c(
              "v-select",
              {
                staticClass: "form-control",
                attrs: {
                  label: "name",
                  options: _vm.availableConditions,
                  disabled: !_vm.canWrite,
                  clearable: false
                },
                model: {
                  value: _vm.selectedCondition,
                  callback: function($$v) {
                    _vm.selectedCondition = $$v
                  },
                  expression: "selectedCondition"
                }
              },
              [_c("div", { attrs: { slot: "no-options" }, slot: "no-options" })]
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }